import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import classnames from 'classnames';
import { IconButton, Dropdown, NavigableMenu } from '@wordpress/components';
import PropTypes from 'prop-types';
/**
 * This is a dropdown menu hidden behind a vertical ellipsis icon. When clicked, the inner MenuItems are displayed.
 */

var EllipsisMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(EllipsisMenu, _Component);

  function EllipsisMenu() {
    _classCallCheck(this, EllipsisMenu);

    return _possibleConstructorReturn(this, _getPrototypeOf(EllipsisMenu).apply(this, arguments));
  }

  _createClass(EllipsisMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          renderContent = _this$props.renderContent;

      if (!renderContent) {
        return null;
      }

      var renderEllipsis = function renderEllipsis(_ref) {
        var onToggle = _ref.onToggle,
            isOpen = _ref.isOpen;
        var toggleClassname = classnames('woocommerce-ellipsis-menu__toggle', {
          'is-opened': isOpen
        });
        return createElement(IconButton, {
          className: toggleClassname,
          onClick: onToggle,
          icon: "ellipsis",
          title: label,
          "aria-expanded": isOpen
        });
      };

      var renderMenu = function renderMenu(renderContentArgs) {
        return createElement(NavigableMenu, {
          className: "woocommerce-ellipsis-menu__content"
        }, renderContent(renderContentArgs));
      };

      return createElement("div", {
        className: "woocommerce-ellipsis-menu"
      }, createElement(Dropdown, {
        contentClassName: "woocommerce-ellipsis-menu__popover",
        position: "bottom left",
        renderToggle: renderEllipsis,
        renderContent: renderMenu
      }));
    }
  }]);

  return EllipsisMenu;
}(Component);

EllipsisMenu.propTypes = {
  /**
   * The label shown when hovering/focusing on the icon button.
   */
  label: PropTypes.string.isRequired,

  /**
   * A function returning `MenuTitle`/`MenuItem` components as a render prop. Arguments from Dropdown passed as function arguments.
   */
  renderContent: PropTypes.func
};
export default EllipsisMenu;
//# sourceMappingURL=index.js.map